import FlexibleDataOptimized from '@lib/cms/flexibleDataOptimized';
import { fetchAssociatedAgent, getAssociatedAgentItem } from '@lib/associatedAgent';
import BuilderDevelopmentTemplate from '@templates/BuilderDevelopment';

export async function getServerSideProps(context) {
  const preview = context.preview || false;
  const { agentid } = context.query;
  let associatedAgent = null;

  const previewEnv = context?.previewData?.environment || null;
  const data = await FlexibleDataOptimized.fetchBuilderDevelopmentPage(
    'Development',
    context.params.slug,
    preview,
    previewEnv
  );

  if (data === null) {
    return {
      notFound: true
    };
  }

  if (agentid && data?.allAgentPermission) {
    associatedAgent = await fetchAssociatedAgent({ agentId: parseInt(agentid) });
  }

  return {
    props: { data, preview, associatedAgent: getAssociatedAgentItem(associatedAgent) }
  };
}

const DevelopmentPage = ({ data, preview, associatedAgent }) => {
  return (
    <BuilderDevelopmentTemplate data={data} preview={preview} associatedAgent={associatedAgent} />
  );
};

export default DevelopmentPage;
